export default __webpack_public_path__ + "static/KeywordResearch_02_04-6fab8248d3ecb53fdddb68ad75c59a23.png";